import { render, staticRenderFns } from "./AppMdlFooter.vue?vue&type=template&id=07e8226b&"
import script from "./AppMdlFooter.vue?vue&type=script&lang=js&"
export * from "./AppMdlFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports